/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhneu_Philologie16Inputs */

const en__field_enum_ikhneu_philologie16 = /** @type {(inputs: _Field_Enum_Ikhneu_Philologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 - Neuere Philologien`)
};

const de__field_enum_ikhneu_philologie16 = /** @type {(inputs: _Field_Enum_Ikhneu_Philologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 - Neuere Philologien`)
};

/**
* | output |
* | --- |
* | "10 - Neuere Philologien" |
*
* @param {_Field_Enum_Ikhneu_Philologie16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhneu_philologie16 = /** @type {((inputs?: _Field_Enum_Ikhneu_Philologie16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhneu_Philologie16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhneu_philologie16(inputs)
	return de__field_enum_ikhneu_philologie16(inputs)
});
export { _field_enum_ikhneu_philologie16 as "_field_enum_IKHNEU_PHILOLOGIE" }